module.exports = __webpack_public_path__ + "img/banner1a.d0190262.jpg";